module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/NeonBroadway-c2e2d8db2a63c3e102773493296f4d9c.gif";